import { BrowserModule } from '@angular/platform-browser';
import { Component, NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxLoadingModule } from 'ngx-loading';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { NotificationsModule } from './views/notifications/notifications.module';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';
import {AuthService } from './_services/auth-service';
import { ErrorService } from './_services/error.service';
import { ApiClientService } from './_services/swagger';
import { ValidatorService } from './_services/validator-service';

import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { FieldErrorDisplayComponent } from './components/validate-form/field-error-display.component';
import { FieldErrorDisplayModule } from './components/validate-form/field-error-display.module';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Alert Component
import { AlertModule } from 'ngx-bootstrap/alert';
import { AlertsComponent } from './views/notifications/alerts.component';

// Modal Component
import { ModalModule } from 'ngx-bootstrap/modal';
import { ModalsComponent } from './views/notifications/modals.component';
import { MainPipeModule } from './pipe/mainpipe.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService } from '@progress/kendo-angular-l10n';
import { KendoMessageService } from './_services/kendo-message.service';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    FieldErrorDisplayModule,
    MainPipeModule,
    NgxLoadingModule.forRoot({})
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    AlertsComponent,
    ModalsComponent,
    // FieldErrorDisplayComponent,

  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: MessageService,
      useClass: KendoMessageService
    },
  AuthService,
  ApiClientService,
  ValidatorService,
  ErrorService,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
